<div class="seed-container">
    <div class="seed-login" *ngIf="!isLoggedIn">
        <form [formGroup]="login" (ngSubmit)="onLogin()">
            <label for="email">Email</label>
            <input id="email" formControlName="email" type="email" />
            <label for="password">Password</label>
            <input id="password" formControlName="password" type="password" />
            <button type="submit" class="tf-btn" [disabled]="login.invalid">Login</button>

            <span *ngIf="isLoginInError">C'è stato un errore durante la login.</span>
        </form>
    </div>

    <div class="seed-actions" *ngIf="isLoggedIn">
        <div>
            <form>
                <label for="userCount">Numero di utenti da creare</label>
                <input id="userCount" name="userCount" type="number" [(ngModel)]="userCount" min="1" />
                <button (click)="onSeedUsers()" class="tf-btn">Crea Utenti</button>

                <span *ngIf="areUserSeeded">Utenti aggiunti con successo!</span>
                <span *ngIf="usersSeedError">C'è stato un errore durante l'aggiunta: {{usersSeedError}}</span>
            </form>
        </div>
        <div>
            <form>
                <label for="ticketCount">Numero di ticket da creare <i>(Se non dovessero esserci abbastanza utenti, verranno creati ticket fino al massimo degli utenti disponibili)</i></label>
                <input id="ticketCount" name="ticketCount" type="number" [(ngModel)]="ticketCount" min="1" />
                <button (click)="onSeedTickets()" class="tf-btn">Crea Ticket</button>

                <span *ngIf="areTicketsSeeded">Ticket aggiunti con successo!</span>
                <span *ngIf="ticketsSeedError">C'è stato un errore durante l'aggiunta: {{ticketsSeedError}}</span>
            </form>
        </div>
    </div>
</div>